package one.healthium.uscreen.ui.util

import one.healthium.uscreen.domain.models.BlockCondition
import one.healthium.uscreen.domain.models.UScreenBlock
import one.healthium.uscreen.ui.UScreenAnswer

fun BlockCondition.evaluate(answers: Map<String, UScreenAnswer>): Boolean {
    val answer = answers[key] as? UScreenAnswer.ChoiceAnswer ?: return false
    val selected = answer.selectedKeys
    val eqResult = eq?.let { it in selected } ?: true
    val neqResult = neq?.let { it !in selected } ?: true
    return eqResult && neqResult
}

fun UScreenBlock.isVisible(answers: Map<String, UScreenAnswer>): Boolean {
    return condition?.evaluate(answers) ?: true
}
